import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'processing',
  templateUrl: './processing.component.html',
  styleUrls: ['./processing.component.scss']
})
export class ProcessingComponent implements OnInit {
  
  @Input()
	set text(name: string) {
		this.processingText = name.toUpperCase();
	}
	get name(): string {
		return this.processingText;
	}

	public processingText = 'Cargando...'; // Valor por defecto

  @Input() showProcessing: boolean = true;
  constructor() { }

  ngOnInit() {
  }
  
}
